import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
    static targets = ['modal','form'];

    openModal(event){
        const params = event.params;
        const modal = this.modalTarget;
        document.getElementById("deny_url").value = params.url;
        modal.setAttribute("style", "display: block;")
    }
    closeModal(event){
        const modal = this.modalTarget;
        modal.setAttribute("style", "display: none;")
    }
    sendDeny(event){
        const formData = new FormData(this.formTarget);
        Rails.ajax({
            url: document.getElementById("deny_url").value,
            type: "POST",
            dataType: 'json',
            data: formData,
            success: (response)=> {

            }
        });
    }
}
